import { type DueDose, type MedicationAdministration } from '@/api/medications';
import { clinicalAuthorLine } from '@/utils/clinical-author';

// "Dio Rosa Díaz · Registrado por Ana Pérez · Coordinadora": the Ejecutor and the Autor.
export function recordPeople(record: MedicationAdministration): string {
  const recorded = record.author ? clinicalAuthorLine(record.author) : record.recordedBy;

  return [record.performer ? `Dio ${record.performer}` : null, recorded].filter(Boolean).join(' · ');
}

function isPast(dose: DueDose): boolean {
  return new Date(dose.scheduledAt) < new Date();
}

export function doseStatusColor(dose: DueDose): string {
  const record = dose.administration;
  if (!record) return isPast(dose) && dose.covered ? 'warning' : 'default';

  return record.state === 'completed' ? 'success' : 'error';
}

export function doseStatusText(dose: DueDose): string {
  const record = dose.administration;
  if (!record && !dose.covered) return 'Sin turno';
  if (!record) return isPast(dose) ? 'Pendiente' : 'Por dar';

  return record.state === 'completed' ? `Administrada ${record.givenTime}` : record.humanStatus;
}
